module.exports = __webpack_public_path__ + "img/new_3.3ba3034e.png";